import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { dayjs } from "@/utils/dayjs";
import { TCreateMatchReqDto } from "@/api/services/admin/match/dtos/create-match.dto";
import { TUpdateMatchReqDto } from "@/api/services/admin/match/dtos/update-match.dto";
import { TMatchForm } from "@/features/match/types/matchForm";
import { TGetMatchDto } from "@/api/services/admin/match/dtos/get-match.dto";

export const convertMatchFormToCreateReq = (data: TMatchForm, organizationId?: number, productContractId?: number): TCreateMatchReqDto => {
  return {
    organizationId: organizationId ?? null,
    productContractId: productContractId ?? null,
    matchName: data.matchName,
    matchLicenseNumber: data.matchLicenseNumber,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
  };
};

export const convertMatchFormToUpdateReq = (data: TMatchForm): TUpdateMatchReqDto => {
  return {
    ...data,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate ? data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) : null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
  };
};

export const convertMatchResToForm = (data: TGetMatchDto): TMatchForm => {
  return {
    matchName: data.matchName,
    matchLicenseNumber: data.matchLicenseNumber,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    description: data.description ?? null,
    note: data.note ?? null,
    trialStartDate: data.trialStartDate ? dayjs(data.trialStartDate) : null,
    trialEndDate: data.trialEndDate ? dayjs(data.trialEndDate) : null,
    contractEndDate: data.contractEndDate ? dayjs(data.contractEndDate) : null,
    contractStartDate: dayjs(data.contractStartDate),
  };
};
